import { gql } from 'apollo-angular';

export const LoginByReReDocument = gql`
  mutation LoginV2($data: AuthV2Input!) {
    loginV2(data: $data) {
      token
      employee {
        re
      }
    }
  }
`;